import * as types from '../constants/ActionTypes';
import client from '../lib/frost-web-client';
import { push } from 'react-router-redux';
import { setGlobalMsg } from './global-msg';
import logout from '../lib/logout';
import { receiveCorp } from './corporations';
import { receiveBuilder } from './builders';

//SUBDIVISIONS
export function requestSubdivisionList() {
	return { type: types.REQUEST_SUBDIVISION_LIST };
}

export function receiveSubdivisionList(response) {
	return { type: types.RECEIVE_SUBDIVISION_LIST, response };
}

export function requestSubdivision () {
	return { type: types.REQUEST_SUBDIVISION };
}

export function receiveSubdivision (subdivision) {
	return { type: types.RECEIVE_SUBDIVISION, subdivision };
}

export function receiveSubdivisionListError(error) {
	return { type: types.RECEIVE_SUBDIVISION_LIST_ERROR, error };
}

export function receiveSubdivisionError(error) {
	return { type: types.RECEIVE_SUBDIVISION_ERROR, error };
}

export function fetchSubdivisionList(params) {
	return dispatch => {

		dispatch(requestSubdivisionList());

		return client.get('/api/subdivisions', params)
			.then(response => dispatch(receiveSubdivisionList(response.body)))
			.catch(error => {
				if (!logout(error, dispatch)) {
					dispatch(receiveSubdivisionListError(error.response));
				}
			});
	};
}

export function fetchSubdivision (subdivisionId, params) {
	return dispatch => {

		dispatch(requestSubdivision());

		client.get(`/api/subdivisions/${subdivisionId}`, params)
			.then(response => {

				// Set the subdivision
				dispatch(receiveSubdivision(response.body));

				// Set the corporation and builder if they were returned
				if (response.body.corporation) {
					dispatch(receiveCorp(response.body.corporation));
				}
				if (response.body.builder) {
					dispatch(receiveBuilder(response.body.builder));
				}

			})
			.catch(error => {
				if (!logout(error, dispatch)) {
					switch (error.status) {
						case 404:
							dispatch(push('/'));
							break;
						default:
							if (error.response && error.response.body) {
								dispatch(receiveSubdivisionError(error.response.body));
							} else {
								console.error(error.stack);
								dispatch(setGlobalMsg('error', 'An unknown error occurred.'));
							}
					}
				}
			});
	};
}

//SUBDIVISION EDIT
export function submitEditSubdivision() {
	return { type: types.SUBMIT_EDIT_SUBDIVISION };
}

export function resolveEditSubdivision(subdivision) {
	let success = {
		message: 'Subdivision edited.'
	}
	return { type: types.RESOLVE_EDIT_SUBDIVISION, success, subdivision };
}

export function resolveEditSubdivisionError(error) {
	return { type: types.RESOLVE_EDIT_SUBDIVISION_ERROR, error };
}

export function editSubdivision(subdivision) {
	return dispatch => {

		dispatch(submitEditSubdivision());

		return client.put('/api/subdivisions/' + subdivision.id, subdivision)
			.then(response => {
				dispatch(resolveEditSubdivision(subdivision));
			})
			.catch(error => {
				if (!logout(error, dispatch)) {
					dispatch(resolveEditSubdivisionError(error.response));
				}
			});

	};
}

//SUBDIVISION Enable All for Single Builder
export function resolveUpdateSubdivisionStatus(builderId, isFeedEnabled) {
	return { type: types.RESOLVE_UPDATE_SUBDIVISION_STATUS, builderId, isFeedEnabled };
}

export function resolveUpdateSubdivisionStatusError(error) {
	return { type: types.RESOLVE_UPDATE_SUBDIVISION_STATUS_ERROR, error };
}

export function updateSubdivisionStatus(builderId, isFeedEnabled) {
	return dispatch => {

		return client.put('/api/builders/' + builderId + '/subdivisions', { isFeedEnabled })
			.then(response => dispatch(resolveUpdateSubdivisionStatus(builderId, isFeedEnabled)))
			.catch(error => {
				if (!logout(error, dispatch)) {
					dispatch(resolveUpdateSubdivisionStatusError(error.response));
				}
			});
	};
}



// WEBPACK FOOTER //
// ./src/assets/js/actions/subdivisions.js